var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[(_vm.dimeObj.editType != '8')?[_vm._v(" "+_vm._s(_vm.dimeObj.dimeText)+" ")]:_vm._e(),(_vm.dimeObj.editType == '8')?[_c('fileList',{attrs:{"fileList":_vm.dimeObj.dimeValue}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }